import { ReactElement } from 'react';
import styles from './BasicTooltip.module.scss';
import { Tooltip } from 'react-leaflet';
import { TooltipOptions } from 'leaflet';

export interface BasicTooltipProps extends Pick<TooltipOptions, 'permanent' | 'interactive'> {
  text: string;
  offset?: [number, number];
}

export function BasicTooltip({
  text,
  offset = [0, 22], // Approximately half the height of the tooltip.
  interactive = false,
  permanent = false,
}: BasicTooltipProps): ReactElement {
  // Concatenate the props that React Leaflet treats as readonly after initial render.
  const renderKey = `${permanent}-${interactive}-${offset.join(',')}`;
  return (
    <Tooltip
      key={renderKey}
      className={styles.container}
      direction="top"
      sticky={false}
      permanent={permanent}
      opacity={1}
      interactive={interactive}
      offset={offset}
    >
      <div className={styles.title}>{text}</div>
    </Tooltip>
  );
}

export default BasicTooltip;
